module.exports = __webpack_public_path__ + "static/img/index_header_up_bg-2.2c6bf20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/index_header_up_bg-2.png
// module id = 979
// module chunks = 0